module.exports = __webpack_public_path__ + "static/023-df6ef22cbffee0a591f02e7e71e55587.jpg";